export default __webpack_public_path__ + "static/media/asian-woman-pose.a86997e8.jpg";